import {Injectable} from '@angular/core';
import {NotificationType} from "./notification-type";
import {Observable, Subject} from "rxjs";
import {NotificationData} from "./notification-data";
import {CdColor} from "../../enums/cd-color";
import {IconFont} from "../../enums/icon-font";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private _pushListener = new Subject<NotificationData>();
  constructor() { }

  push(text: string, color: CdColor, icon: IconFont): void {
    this._pushListener.next({text, color, icon});
  }

  onNotificationPushed(): Observable<NotificationData> {
    return this._pushListener;
  }
}
